import request from '@/router/axios'

const API = '/api/produce/kanban/truck-efficiency-leaderboard'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

function n(v) {
  const x = Number(v)
  return Number.isFinite(x) ? x : null
}

function nb(v) {
  const x = n(v)
  return x != null ? x : 0
}

export function fetchTruckEfficiencyLeaderboard(params = {}) {
  return request({
    url: API,
    method: 'post',
    data: {
      startDate: params.startDate,
      endDate: params.endDate,
      businessType: params.businessType,
      stockId: params.stockId,
      groupBy: params.groupBy || 'plate',
      metric: params.metric || 'tons',
      limit: params.limit != null ? params.limit : 20
    }
  })
    .then(unwrap)
    .then((d) => {
      if (!d || typeof d !== 'object') {
        return {
          startDate: null,
          endDate: null,
          businessType: null,
          groupBy: 'plate',
          metric: 'tons',
          summary: {},
          items: []
        }
      }
      const items = (d.items || []).map((it) => ({
        dimensionKey: it.dimensionKey,
        tripCount: nb(it.tripCount),
        totalNetWeight: nb(it.totalNetWeight),
        avgPlantStaySeconds: it.avgPlantStaySeconds != null ? n(it.avgPlantStaySeconds) : null,
        avgTonPerTrip: it.avgTonPerTrip != null ? n(it.avgTonPerTrip) : null,
        rankValue: it.rankValue != null ? n(it.rankValue) : null,
        sampleCustName: it.sampleCustName
      }))
      const s = d.summary || {}
      return {
        startDate: d.startDate,
        endDate: d.endDate,
        businessType: d.businessType,
        groupBy: d.groupBy || 'plate',
        metric: d.metric || 'tons',
        summary: {
          totalTrips: nb(s.totalTrips),
          totalNetWeightTons: nb(s.totalNetWeightTons),
          avgPlantStaySeconds: s.avgPlantStaySeconds != null ? n(s.avgPlantStaySeconds) : null,
          distinctPlateCount: nb(s.distinctPlateCount)
        },
        items
      }
    })
}
